<form [formGroup]="dealerRepForm">
    <div class="field-container">
        <mat-form-field>
            <mat-label>First Name</mat-label>
            <input matInput #input required minlength="2" maxlength="50" formControlName="firstName"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Last Name</mat-label>
            <input matInput #input required minlength="2" maxlength="50" formControlName="lastName"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput #input required maxlength="255" formControlName="email"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Phone</mat-label>
            <input matInput #input required maxlength="15" formControlName="phone"/>
        </mat-form-field><br>
    </div>
</form>